import axios from "../utils/axios.wrapper";

export const getSubscriptionsByCompany = async (companyId) => {
  const { data } = await axios.get(`/companySubscription/company/${companyId}`);
  return data ?? [];
};

export const getActiveSubscription = async (companyId) => {
  const { data } = await axios.get(`/companySubscription/company/${companyId}/active`);
  return data;
};

export const createSubscription = async (subscription) => {
  const { data } = await axios.post("/companySubscription", subscription);
  return data;
};

export const updateSubscription = async (id, subscription) => {
  const { data } = await axios.put(`/companySubscription/${id}`, subscription);
  return data;
};

export const cancelSubscription = async (id, reason) => {
  const { data } = await axios.post(`/companySubscription/${id}/cancel`, { reason });
  return data;
};

export const companySubscriptionService = {
  getSubscriptionsByCompany,
  getActiveSubscription,
  createSubscription,
  updateSubscription,
  cancelSubscription,
};